import React, { useEffect } from 'react'
import { useHistory } from 'react-router'

export const HomePageOrder = () => {
    const history = useHistory();
    const redirectToPatch = () => {
        history.push('/orderDisbursement')

    }
    useEffect(() => {
        redirectToPatch();
    })
    return (
        <>
            
        </>
    )
}
